// MarcaOptimizacion — P3-9b. Etiqueta sobre la foto (esquina inferior izquierda,
// estilo «Principal»), nunca en lugar de otro control. Cuatro estados, exactamente
// uno por foto: «Optimizada» (verde), «Pesada» (ámbar), «Cumple» (gris discreto),
// «Baja resolución» (ámbar claro — no se sirve nítida en escritorio).
import React from 'react';

const TEXTO = { optimizada: 'Optimizada', pesada: 'Pesada', cumple: 'Cumple', 'baja-resolucion': 'Baja resolución' };

export default function MarcaOptimizacion({ distintivo }) {
  if (!TEXTO[distintivo]) return null;
  return (
    <span className={`pp-fotomarca pp-fotomarca--${distintivo}`}>{TEXTO[distintivo]}</span>
  );
}
